<template>
  <div id="fleet-selector" :class="{ hidden: getFleets.length <= 1 }">
    <v-select
      v-if="selectedFleet"
      :items="getFleetsSorted"
      item-text="name"
      item-value="id"
      dense
      outlined
      @input="changeFleet"
      :value="getFleets.find((fleet) => fleet.id === getFleetId)"
    >
    </v-select>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  props: {
    update: { type: Function }
  },
  data () {
    return {
      selected: null
    }
  },
  mounted () {
    this.getVehicleFleet(this.$route.params.fleetId)
  },
  computed: {
    ...mapState(['vehicles']),
    ...mapGetters('vehicle', ['getFleets', 'getFleetId']),
    selectedFleet () {
      const fleetTmp = this.getFleets.filter(fleet => fleet.id === this.getFleetId)
      return fleetTmp.length === 0 ? null : fleetTmp[0]
    },
    getFleetsSorted () {
      var fleets = [...this.getFleets]
      return fleets.sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  methods: {
    ...mapActions('vehicle', ['selectFleetById', 'availableEvse', 'getVehicleFleet']),
    async changeFleet (fleetId) {
      await this.selectFleetById(fleetId)
      await this.availableEvse(fleetId)
      if (this.update) {
        this.update()
      }
      await this.$router.push({
        name: this.$route.name,
        params: {
          fleetId: fleetId
        }
      })
    }
  }
}
</script>
<style scoped>
#fleet-selector {
  width: 232px;
}

.hidden {
  opacity: 0;
  pointer-events: none;
}
</style>
